import { Http } from "../Http";
import { AxiosPromise } from "axios";
import { getUserAccessToken } from "../selectors/Accounts";
import { exceptionHandler } from "../../pages/common/functions";

export class VideoHotlineService {
	public static videoHotlineGetByfilter(input: any) {
		return Http.axios()
			.post(`/api/Messages/getallvideohotline`, input, {
				headers: { Authorization: getUserAccessToken() },
			})
			.catch((e: { response: any }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static videoHotlineGetDetail(id: any) {
		return Http.axios()
			.get(`/api/Messages/getvideohotlinebyid/${id}`, {
				headers: { Authorization: getUserAccessToken() },
			})
			.catch((e: { response: any }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static getMessageBoardID(input: any) {
		return Http.axios()
			.get(`/api/Messages/get-message-board-id/${input}`, {
				headers: { Authorization: getUserAccessToken() },
			})
			.then((res: any) => {
				return res;
			})
			.catch((e: any) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static videoHotlineDelete(input: any) {
		return Http.axios()
			.delete("/api/Messages/delete-video-hotline/" + input, {
				headers: { Authorization: getUserAccessToken() },
			})
			.catch((e: { response: any }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static getEventCategoriesApi() {
		return Http.axios()
			.get("/api/EventCategories/GetEventCategoriesForDDL", {
				headers: { Authorization: getUserAccessToken() },
			})
			.then((res: any) => {
				var response = exceptionHandler(res);
				return response?.data;
			})
			.catch((e: { response: any }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}
}
